import ImageWithZoom from './ImageWithZoom';

import WithStore from '../Store/WithStore';

export default WithStore(ImageWithZoom, () => ({}));
